import './Checkout/checkout-fields';
import './Checkout/b2b-toggle';
import './Checkout/shipping-address-toggle';
import './Account/swift-cart';
import '../blocks/frontend';

import { ViewOrderPage } from './Account/ViewOrderPage';
import { ViewOrdersTable } from './Account/ViewOrdersTable';
import { OrderItemPage } from './Product/OrderItemPage';
import { FindRetailerLink } from './Product/FindRetailerLink';
import { DeleteOrderButton } from './Account/order/DeleteOrderButton';

const viewOrderPageElement = document.querySelector( '.woocommerce-view-order' );

( function( $, window ) {
	if ( viewOrderPageElement ) {
		const viewOrderPage = new ViewOrderPage( viewOrderPageElement );
		viewOrderPage.init();
	}

	const singleProductPageElement = document.querySelector( '.single-product' );

	if ( singleProductPageElement ) {
		const orderItemPage = new OrderItemPage( singleProductPageElement );
		const findRetailerLink = new FindRetailerLink( singleProductPageElement );
		orderItemPage.init();
		findRetailerLink.init();
	}

	const deleteOrderButtons = document.querySelectorAll( '.js-qala-b2b-wholesale-delete-order-button' );

	if ( deleteOrderButtons.length > 0 ) {
		deleteOrderButtons.forEach( element => {
			const deleteOrderButton = new DeleteOrderButton( element );
			deleteOrderButton.init();
		} );
	}

	const viewOrdersTable = document.querySelector( '.woocommerce-orders-table' );

	if ( viewOrdersTable ) {
		const viewOrdersTableInstance = new ViewOrdersTable( viewOrdersTable );
		viewOrdersTableInstance.init();
	}

	$( '.composite_data' ).on( 'wc-composite-initializing', function( event, composite ) {
		window.QalaB2bWholesale.composite = composite;
	} );
}( jQuery, window, document ) );
